import { render, staticRenderFns } from "./FormHistory.vue?vue&type=template&id=56c24f53"
import script from "./FormHistory.vue?vue&type=script&lang=js"
export * from "./FormHistory.vue?vue&type=script&lang=js"
import style0 from "./FormHistory.vue?vue&type=style&index=0&id=56c24f53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports